var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 35,
    viewBox: "0 0 119 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.593 35H4.40741C1.98444 35 0 33.0302 0 30.625V4.375C0 1.96984 1.98444 -2.87444e-06 4.40741 -2.87444e-06H114.593C117.016 -2.87444e-06 119 1.96984 119 4.375V30.625C119 33.0302 117.016 35 114.593 35Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.593 0.70109C116.633 0.70109 118.294 2.34937 118.294 4.375V30.625C118.294 32.6506 116.633 34.2989 114.593 34.2989H4.40741C2.36678 34.2989 0.706287 32.6506 0.706287 30.625V4.375C0.706287 2.34937 2.36678 0.70109 4.40741 0.70109H114.593ZM114.593 -2.87444e-06H4.40741C1.98444 -2.87444e-06 0 1.96984 0 4.375V30.625C0 33.0302 1.98444 35 4.40741 35H114.593C117.016 35 119 33.0302 119 30.625V4.375C119 1.96984 117.016 -2.87444e-06 114.593 -2.87444e-06Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19785 6.59617C8.93891 6.86523 8.78906 7.28414 8.78906 7.82664V27.1773C8.78906 27.7198 8.93891 28.1387 9.19785 28.4077L9.26176 28.4668L20.1855 17.6277V17.3718L9.26176 6.53273L9.19785 6.59617Z",
    fill: "url(#paint0_linear_308_23921)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8228 21.2422L20.1855 17.6273V17.3714L23.8272 13.7566L23.9087 13.8036L28.2213 16.2394C29.4521 16.9306 29.4521 18.0681 28.2213 18.7638L23.9087 21.1952L23.8228 21.2422V21.2422Z",
    fill: "url(#paint1_linear_308_23921)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9091 21.1949L20.1859 17.4992L9.19824 28.4071C9.60703 28.8337 10.2736 28.8851 11.0317 28.4585L23.9091 21.1949",
    fill: "url(#paint2_linear_308_23921)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9081 13.8042L11.0307 6.54063C10.2727 6.11844 9.60605 6.16984 9.19727 6.59641L20.1849 17.5L23.9081 13.8042Z",
    fill: "url(#paint3_linear_308_23921)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7974 8.96226C41.7974 9.69289 41.577 10.278 41.1429 10.7144C40.6437 11.2318 39.9936 11.4921 39.197 11.4921C38.4356 11.4921 37.7855 11.2274 37.2522 10.7057C36.7178 10.1763 36.4512 9.52664 36.4512 8.74898C36.4512 7.97133 36.7178 7.32164 37.2522 6.79664C37.7855 6.27055 38.4356 6.00586 39.197 6.00586C39.576 6.00586 39.9374 6.08352 40.2823 6.22789C40.6261 6.37336 40.906 6.57023 41.1087 6.81305L40.6481 7.27461C40.2944 6.86008 39.8129 6.65555 39.197 6.65555C38.6417 6.65555 38.1601 6.84805 37.7514 7.23633C37.347 7.6257 37.1442 8.12992 37.1442 8.74898C37.1442 9.36804 37.347 9.87664 37.7514 10.266C38.1601 10.6499 38.6417 10.8468 39.197 10.8468C39.7865 10.8468 40.2823 10.6499 40.6735 10.2616C40.9313 10.0046 41.0778 9.65023 41.1164 9.19742H39.197V8.56523H41.7577C41.7885 8.70195 41.7974 8.83429 41.7974 8.96226V8.96226Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8597 6.77117H43.4544V8.43367H45.6228V9.06586H43.4544V10.7284H45.8597V11.3726H42.7734V6.12695H45.8597V6.77117Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7266 11.3726H48.0457V6.77117H46.5703V6.12695H50.2031V6.77117H48.7266V11.3726V11.3726Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.832 11.3726V6.12695H53.5119V11.3726H52.832Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5255 11.3726H55.85V6.77117H54.3691V6.12695H58.0063V6.77117H56.5255V11.3726Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8841 10.6969C64.3629 11.2274 63.7172 11.4921 62.947 11.4921C62.1724 11.4921 61.5268 11.2274 61.0056 10.6969C60.4855 10.1676 60.2266 9.51789 60.2266 8.74898C60.2266 7.98008 60.4855 7.33039 61.0056 6.80101C61.5268 6.27055 62.1724 6.00586 62.947 6.00586C63.7128 6.00586 64.3585 6.27055 64.8797 6.80539C65.4042 7.33914 65.6631 7.98445 65.6631 8.74898C65.6631 9.51789 65.4042 10.1676 64.8841 10.6969ZM61.5091 10.2573C61.9014 10.6499 62.3785 10.8468 62.947 10.8468C63.5112 10.8468 63.9927 10.6499 64.3806 10.2573C64.7717 9.8646 64.97 9.36039 64.97 8.74898C64.97 8.13758 64.7717 7.63336 64.3806 7.2407C63.9927 6.84805 63.5112 6.65117 62.947 6.65117C62.3785 6.65117 61.9014 6.84805 61.5091 7.2407C61.118 7.63336 60.9196 8.13758 60.9196 8.74898C60.9196 9.36039 61.118 9.8646 61.5091 10.2573V10.2573Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6182 11.3726V6.12695H67.4446L70.0141 10.2066H70.0438L70.0141 9.1982V6.12695H70.6939V11.3726H69.9843L67.2936 7.09164H67.2638L67.2936 8.10445V11.3726H66.6182V11.3726Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0595 19.034C57.9891 19.034 56.2978 20.5981 56.2978 22.756C56.2978 24.8965 57.9891 26.477 60.0595 26.477C62.1343 26.477 63.8256 24.8965 63.8256 22.756C63.8256 20.5981 62.1343 19.034 60.0595 19.034ZM60.0595 25.0113C58.9235 25.0113 57.9462 24.0805 57.9462 22.756C57.9462 21.414 58.9235 20.4996 60.0595 20.4996C61.1955 20.4996 62.1773 21.414 62.1773 22.756C62.1773 24.0805 61.1955 25.0113 60.0595 25.0113V25.0113ZM51.8518 19.034C49.777 19.034 48.0901 20.5981 48.0901 22.756C48.0901 24.8965 49.777 26.477 51.8518 26.477C53.9255 26.477 55.6135 24.8965 55.6135 22.756C55.6135 20.5981 53.9255 19.034 51.8518 19.034ZM51.8518 25.0113C50.7147 25.0113 49.7341 24.0805 49.7341 22.756C49.7341 21.414 50.7147 20.4996 51.8518 20.4996C52.9878 20.4996 53.9652 21.414 53.9652 22.756C53.9652 24.0805 52.9878 25.0113 51.8518 25.0113ZM42.085 20.1748V21.7563H45.8897C45.7784 22.6401 45.4809 23.2898 45.0247 23.7426C44.4694 24.2895 43.6045 24.8965 42.085 24.8965C39.7436 24.8965 37.9101 23.0207 37.9101 20.6965C37.9101 18.3723 39.7436 16.4965 42.085 16.4965C43.351 16.4965 44.2722 16.9876 44.952 17.6241L46.0748 16.5096C45.1239 15.6084 43.859 14.916 42.085 14.916C38.8742 14.916 36.1758 17.5093 36.1758 20.6965C36.1758 23.8837 38.8742 26.477 42.085 26.477C43.8204 26.477 45.1239 25.9126 46.1486 24.8538C47.1987 23.8115 47.5259 22.3459 47.5259 21.1624C47.5259 20.7949 47.4951 20.457 47.44 20.1748H42.085ZM82.0227 21.4009C81.7131 20.5685 80.7578 19.034 78.8119 19.034C76.8837 19.034 75.2783 20.5423 75.2783 22.756C75.2783 24.8407 76.8671 26.477 78.997 26.477C80.7192 26.477 81.7131 25.4346 82.1219 24.8276L80.8437 23.9821C80.4173 24.6012 79.8366 25.0113 78.997 25.0113C78.1629 25.0113 77.5646 24.6318 77.1812 23.8837L82.1957 21.8241L82.0227 21.4009V21.4009ZM76.9101 22.6401C76.8671 21.2051 78.0329 20.4701 78.8681 20.4701C79.5226 20.4701 80.0779 20.7949 80.2631 21.2598L76.9101 22.6401V22.6401ZM72.8344 26.2505H74.4827V15.3131H72.8344V26.2505ZM70.1348 19.8631H70.0797C69.7095 19.4277 69.0032 19.034 68.1085 19.034C66.231 19.034 64.5143 20.6702 64.5143 22.768C64.5143 24.8538 66.231 26.477 68.1085 26.477C69.0032 26.477 69.7095 26.0799 70.0797 25.6315H70.1348V26.1652C70.1348 27.5882 69.369 28.3527 68.1339 28.3527C67.1268 28.3527 66.502 27.6309 66.2442 27.0238L64.8107 27.6177C65.2239 28.6043 66.318 29.8184 68.1339 29.8184C70.0665 29.8184 71.6973 28.6896 71.6973 25.9432V19.2604H70.1348V19.8631V19.8631ZM68.2496 25.0113C67.1136 25.0113 66.1627 24.0674 66.1627 22.768C66.1627 21.4566 67.1136 20.4996 68.2496 20.4996C69.369 20.4996 70.2516 21.4566 70.2516 22.768C70.2516 24.0674 69.369 25.0113 68.2496 25.0113V25.0113ZM89.7401 15.3131H85.7976V26.2505H87.4416V22.1063H89.7401C91.5658 22.1063 93.3563 20.7949 93.3563 18.7091C93.3563 16.6245 91.5614 15.3131 89.7401 15.3131V15.3131ZM89.783 20.5849H87.4416V16.8345H89.783C91.0105 16.8345 91.7113 17.8462 91.7113 18.7091C91.7113 19.5557 91.0105 20.5849 89.783 20.5849ZM99.9454 19.0132C98.7576 19.0132 97.5224 19.5338 97.0145 20.6877L98.4733 21.2948C98.7874 20.6877 99.3647 20.4909 99.9752 20.4909C100.828 20.4909 101.693 20.9995 101.706 21.8974V22.0123C101.409 21.8416 100.772 21.589 99.9884 21.589C98.4172 21.589 96.8162 22.4476 96.8162 24.0499C96.8162 25.5155 98.1031 26.4595 99.5499 26.4595C100.656 26.4595 101.267 25.964 101.65 25.3876H101.706V26.233H103.294V22.0374C103.294 20.0982 101.835 19.0132 99.9454 19.0132ZM99.7471 25.007C99.2094 25.007 98.4601 24.7423 98.4601 24.0806C98.4601 23.234 99.3945 22.9091 100.203 22.9091C100.927 22.9091 101.267 23.0677 101.706 23.2766C101.577 24.2895 100.699 25.007 99.7471 25.007V25.007ZM109.079 19.2527L107.189 23.9941H107.133L105.179 19.2527H103.406L106.342 25.8787L104.667 29.5657H106.385L110.908 19.2527H109.079V19.2527ZM94.2599 26.2505H95.9082V15.3131H94.2599V26.2505Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_308_23921",
    x1: 19.2156,
    y1: 27.3788,
    x2: 4.53141,
    y2: 12.5858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_308_23921",
    x1: 29.824,
    y1: 17.4982,
    x2: 8.4949,
    y2: 17.4982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_308_23921",
    x1: 21.8845,
    y1: 15.4901,
    x2: 1.97155,
    y2: -4.57041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_308_23921",
    x1: 6.43144,
    y1: 34.8458,
    x2: 15.3235,
    y2: 25.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.dffaed25a20420235913ccb0206e3a44.svg";
export { ForwardRef as ReactComponent };